var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTapeworm = function SvgTapeworm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 56 56"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#B4EEF3",
    d: "M28.335 4.918c12.565 0 22.75 10.185 22.75 22.75s-10.185 22.75-22.75 22.75-22.75-10.185-22.75-22.75 10.185-22.75 22.75-22.75"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M33.962 16.013a2.75 2.75 0 0 0 2.748-2.748c0-1.523-1.243-2.765-2.748-2.765h-1.61l-1.365 2.748 1.365 2.747h1.61z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M32.355 16.013V10.5h-4.357l-1.365 2.748 1.365 2.765z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M28 16.013V10.5h-4.357l-1.365 2.94 1.365 2.573z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M19.317 16.013h4.323V10.5h-4.358l-1.365 2.748 1.365 2.765h.052z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M19.282 16.013V10.5c-2.135 0-4.06.875-5.46 2.275l1.295 3.237 2.608.665a2.2 2.2 0 0 1 1.557-.665"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M17.113 18.113c0-.56.245-1.05.613-1.418l-3.903-3.902a7.72 7.72 0 0 0-2.222 5.442l3.29 1.505 2.222-1.505v-.122"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M17.113 18.218h-5.512a7.52 7.52 0 0 0 2.292 5.39l3.133-1.296.752-2.59a2.15 2.15 0 0 1-.665-1.505"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M19.284 20.335a2.15 2.15 0 0 1-1.488-.595l-3.885 3.885a7.73 7.73 0 0 0 5.373 2.223l1.627-2.678z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M19.284 20.335v5.513h4.358l1.277-2.923-1.277-2.59z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M23.639 20.335v5.513h4.357l1.488-3.063-1.488-2.45z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M28 20.335v5.513h4.358l1.312-2.8-1.312-2.713z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M36.625 20.335h-4.27v5.513h4.357l1.487-2.45-1.487-3.063z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M36.716 20.335v5.513a2.15 2.15 0 0 1 1.487.595l3.115-.385.77-3.5a7.73 7.73 0 0 0-5.372-2.223"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M44.397 27.947a7.52 7.52 0 0 0-2.292-5.39l-3.885 3.885c.402.385.647.91.665 1.505l2.992 1.015z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M38.88 27.947v.105c0 .56-.245 1.05-.612 1.418l1.505 2.677 2.397 1.225a7.72 7.72 0 0 0 2.223-5.442H38.88z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "m36.715 30.153-1.435 2.765 1.435 2.765c2.135 0 4.06-.875 5.46-2.275l-3.902-3.903a2.2 2.2 0 0 1-1.558.665z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M36.675 30.153h-4.323l-1.365 2.904 1.365 2.608h4.358v-5.512h-.053z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "m28 30.153-1.75 2.677L28 35.665h4.358v-5.512z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "M23.638 30.153 22.08 33.39l1.558 2.275h4.357v-5.512z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "m18.184 32.445 1.312 2.922 2.59.98a2.2 2.2 0 0 1 1.558-.665V30.17c-2.135 0-4.06.875-5.46 2.275"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "m15.976 37.87 2.905.77 2.607-.77v-.105c0-.56.245-1.05.613-1.418l-3.903-3.902a7.72 7.72 0 0 0-2.222 5.443z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M15.976 37.87a7.52 7.52 0 0 0 2.292 5.39l2.923-1.54.962-2.345a2.15 2.15 0 0 1-.665-1.505z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "m23.638 45.5 1.75-2.748-1.75-2.747a2.15 2.15 0 0 1-1.487-.595l-3.885 3.885a7.73 7.73 0 0 0 5.372 2.222z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M23.726 45.5h4.27l1.278-2.747-1.278-2.748H23.64v5.513h.087z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "#DE3719",
    d: "m32.358 45.5.735-2.625-.736-2.887H28V45.5z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "#F04B24",
    d: "M33.965 45.5a2.75 2.75 0 0 0 2.747-2.747 2.75 2.75 0 0 0-2.748-2.748h-1.61v5.513h1.61z"
  })));
};
export default SvgTapeworm;